import { render, staticRenderFns } from "./ComboboxProduction.vue?vue&type=template&id=353a84d0&scoped=true&"
import script from "./ComboboxProduction.vue?vue&type=script&lang=js&"
export * from "./ComboboxProduction.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxProduction.vue?vue&type=style&index=0&id=353a84d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a84d0",
  null
  
)

export default component.exports